import { render, staticRenderFns } from "./GameContent.vue?vue&type=template&id=55735ad8&"
import script from "./GameContent.vue?vue&type=script&lang=js&"
export * from "./GameContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports